/* WTA - busca preditiva com fotos na barra do cabecalho */
(function () {
  if (window.__wtaBusca) return;
  window.__wtaBusca = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var LIMITE = 10;

  var css = '' +
    '.wta-ps{position:absolute;z-index:9999;background:#fff;border:1px solid #e5e5e5;border-radius:12px;' +
    'box-shadow:0 12px 32px rgba(0,0,0,.14);overflow:hidden;font-family:inherit;max-height:70vh;overflow-y:auto}' +
    '.wta-ps[hidden]{display:none}' +
    '.wta-ps a.wta-ps__item{display:flex;align-items:center;gap:12px;padding:10px 14px;color:#1a1a1a;text-decoration:none;border-bottom:1px solid #f2f2f2}' +
    '.wta-ps a.wta-ps__item:hover,.wta-ps a.wta-ps__item.is-active{background:#f7f3f3}' +
    '.wta-ps__img{width:52px;height:52px;flex:0 0 52px;object-fit:contain;background:#fafafa;border-radius:8px}' +
    '.wta-ps__txt{display:flex;flex-direction:column;gap:2px;min-width:0}' +
    '.wta-ps__title{font-size:14px;line-height:1.3}' +
    '.wta-ps__ref{font-size:11px;line-height:1.2;color:#777;letter-spacing:.02em}' +
    '.wta-ps__ref:empty{display:none}' +
    '.wta-ps__price{font-size:13px;font-weight:600;color:#b92325}' +
    '.wta-ps__esg{font-size:11px;color:#888;font-weight:400;margin-left:6px}' +
    '.wta-ps__all{display:block;padding:12px 14px;font-size:13px;font-weight:600;color:#b92325;text-decoration:none;text-align:center}' +
    '.wta-ps__all:hover{background:#f7f3f3}' +
    '.wta-ps__empty{padding:14px;font-size:13px;color:#666}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var fmt;
  try { fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }); } catch (e) { fmt = null; }
  function preco(v) { var n = parseFloat(v); return fmt ? fmt.format(n) : 'R$ ' + n.toFixed(2).replace('.', ','); }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function img(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }

  /* REF = SKU da variante, buscado em /products/<handle>.js (com cache) */
  var refCache = {};
  function pegarRef(handle) {
    if (!refCache[handle]) {
      refCache[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var skus = [];
          (p.variants || []).forEach(function (v) {
            if (v.sku && skus.indexOf(v.sku) === -1) skus.push(v.sku);
          });
          if (!skus.length) return '';
          return skus.length > 2 ? skus.slice(0, 2).join(' / ') + ' +' + (skus.length - 2) : skus.join(' / ');
        })
        .catch(function () { return ''; });
    }
    return refCache[handle];
  }
  function preencherRefs(box) {
    box.querySelectorAll('.wta-ps__ref[data-h]').forEach(function (el) {
      pegarRef(el.getAttribute('data-h')).then(function (ref) {
        if (ref) el.textContent = 'REF: ' + ref;
      });
    });
  }

  function iniciar(input) {
    if (input.__wtaPs) return;
    input.__wtaPs = true;
    input.setAttribute('autocomplete', 'off');

    var box = document.createElement('div');
    box.className = 'wta-ps';
    box.hidden = true;
    box.setAttribute('role', 'listbox');
    document.body.appendChild(box);

    var timer = null, ctrl = null, ativo = -1, ultimo = '';

    function posicionar() {
      var r = input.getBoundingClientRect();
      var largura = Math.max(r.width, 380);
      var esquerda = r.right + window.scrollX - largura;
      if (esquerda < 8) esquerda = 8;
      box.style.width = largura + 'px';
      box.style.left = esquerda + 'px';
      box.style.top = (r.bottom + window.scrollY + 6) + 'px';
    }

    function fechar() { box.hidden = true; ativo = -1; }

    function render(q, produtos) {
      var link = ROOT + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      var html = '';
      if (!produtos.length) {
        html = '<div class="wta-ps__empty">Nenhum produto encontrado para “' + esc(q) + '”.</div>';
      } else {
        produtos.forEach(function (p) {
          var foto = (p.featured_image && p.featured_image.url) || p.image;
          html += '<a class="wta-ps__item" role="option" href="' + esc(p.url) + '">' +
            (foto ? '<img class="wta-ps__img" loading="lazy" src="' + esc(img(foto)) + '" alt="' + esc(p.title) + '">' : '<span class="wta-ps__img"></span>') +
            '<span class="wta-ps__txt"><span class="wta-ps__ref" data-h="' + esc(p.handle) + '"></span>' +
            '<span class="wta-ps__title">' + esc(p.title) + '</span>' +
            '<span class="wta-ps__price">' + preco(p.price) +
            (p.available ? '' : '<span class="wta-ps__esg">Esgotado</span>') +
            '</span></span></a>';
        });
      }
      html += '<a class="wta-ps__all" href="' + link + '">Ver todos os resultados para “' + esc(q) + '”</a>';
      box.innerHTML = html;
      ativo = -1;
      posicionar();
      box.hidden = false;
      preencherRefs(box);
    }

    function buscar() {
      var q = input.value.trim();
      if (q.length < 2) { fechar(); ultimo = ''; return; }
      if (q === ultimo && !box.hidden) return;
      ultimo = q;
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=product&resources%5Blimit%5D=' + LIMITE +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (input.value.trim() !== q) return;
          var prods = (d && d.resources && d.resources.results && d.resources.results.products) || [];
          render(q, prods);
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(buscar, 220);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2) { ultimo = ''; buscar(); }
    });
    input.addEventListener('keydown', function (e) {
      var itens = box.querySelectorAll('a');
      if (box.hidden || !itens.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        ativo = e.key === 'ArrowDown' ? Math.min(ativo + 1, itens.length - 1) : Math.max(ativo - 1, 0);
        itens.forEach(function (a, i) { a.classList.toggle('is-active', i === ativo); });
        itens[ativo].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && ativo > -1) {
        e.preventDefault();
        window.location.href = itens[ativo].href;
      } else if (e.key === 'Escape') {
        fechar();
      }
    });
    document.addEventListener('click', function (e) {
      if (e.target !== input && !box.contains(e.target)) fechar();
    });
    window.addEventListener('resize', function () { if (!box.hidden) posicionar(); });
    window.addEventListener('scroll', function () { if (!box.hidden) posicionar(); }, { passive: true });
  }

  function varrer() {
    document.querySelectorAll('form[action$="/search"] input[name="q"]').forEach(function (i) {
      if (i.id === 'cmdk-input') return;
      iniciar(i);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varrer);
  else varrer();
})();
